import { useEffect, useState } from 'react';

// routing
import Routes from 'routes';

// MUI Daatepicker
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

import moment from "moment";
import "moment/locale/ko";

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Loader from 'ui-component/Loader';

import ThemeCustomization from 'themes';
import { dispatch } from 'store';
import { getMenu } from 'store/slices/menu';

// auth provider
import { GoogleLoginProvider as AuthProvider } from 'contexts/GoogleLoginContext';
import { WebSocketProvider } from 'contexts/WebSocketContext';
import AudioManager from 'commponts/AudioMananger';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        dispatch(getMenu()).then(() => {
            setLoading(true);
        });

        moment.locale("ko");

        AudioManager.init();
    }, []);

    if (!loading) return <Loader />;

    return (
        <ThemeCustomization>
            <RTLLayout>
                <Locales>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="ko">
                        <NavigationScroll>
                            <AuthProvider>
                                <WebSocketProvider>
                                    <Routes />
                                    <Snackbar />
                                </WebSocketProvider>
                            </AuthProvider>
                        </NavigationScroll>
                    </LocalizationProvider>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    );
};

export default App;
